import { SearchDropDownForm } from "src/components/common/form/search/SearchDropDownForm";
import { SearchCodeModalForm } from "src/components/common/form/search/SearchCodeModalForm";
import { SearchSectionForm } from "src/components/common/form/search/SearchSectionForm";
import { useInfoFormEvents } from "src/hooks/useInfoFormEvents";
import { useCommonCodeStore } from "src/store/useCommonCodeStore";
import useUiuxStore from "src/store/useUiuxStore";
import { InfoCodeSearchFieldConfig } from "src/types/info-form";
import { defaultSAL6030_R01Filter } from "./Dto_SAL6030_R01";
import { useSAL6030_R01Store } from "./Store_SAL6030_R01";

interface Props {
	onAutoFetch: () => void;
}

const SearchSection_SAL6030_R01 = ({ onAutoFetch }: Props) => {
	const { SAL6030_R01Filter, setSAL6030_R01Filter } = useSAL6030_R01Store();
	const { brandCdList } = useCommonCodeStore();
	const { setCodeSearchModalProps } = useUiuxStore();
	const searchItemCdFocusId = "searchItemCd_SAL6030_R01";

	const infoFieldConfigs: InfoCodeSearchFieldConfig[] = [
		{
			fieldName: "itemCd",
			category: "품목코드",
			focusId: searchItemCdFocusId,
			responseMapping: {
				itemCd: "itemCd",
				itemNm: "itemNm",
			},
			extraFilter: () => ({
				itemCd: SAL6030_R01Filter.itemCd || "",
				itemNm: SAL6030_R01Filter.itemNm || "",
				itemAccount: "400,500,700",
			}),
			onAfterConfirm: () => {
				onAutoFetch();
			},
		},
	];

	const { getFieldHandlers } = useInfoFormEvents({
		editData: SAL6030_R01Filter,
		setEditData: setSAL6030_R01Filter,
		defaultData: defaultSAL6030_R01Filter,
		infoFieldConfigs,
		setCodeSearchModalProps,
		formName: "SAL6030_R01_search",
	});

	return (
		<SearchSectionForm>
			<SearchDropDownForm
				label="브랜드"
				value={SAL6030_R01Filter.brandCd}
				optionList={brandCdList}
				onChangeItem={(selectedItem) => {
					setSAL6030_R01Filter({ brandCd: selectedItem?.minorCd || "" });
					onAutoFetch();
				}}
			/>
			<SearchCodeModalForm
				label="품목코드"
				value={SAL6030_R01Filter.itemCd}
				valueLabel={SAL6030_R01Filter.itemNm}
				handleFoucsId={searchItemCdFocusId}
				onChange={getFieldHandlers("itemCd").onChange}
				onDoubleClick={getFieldHandlers("itemCd").onDoubleClick}
				onKeyDown={getFieldHandlers("itemCd").onEnterKeyDown}
			/>
		</SearchSectionForm>
	);
};

export default SearchSection_SAL6030_R01;
